import { useIntl } from '@capsicum/common';
import { useCallback, useState } from 'react';

const YesOrNoOptions = {
	NO: false,
	YES: true
} as const;

export const useUkSelfCategorisationSophisticatedInvestor = () => {
	const [sophisticatedHasCertificate, setSophisticatedHasCertificate] = useState<boolean | null>(null);
	const [sophisticatedFirmName, setSophisticatedFirmName] = useState<string>('');
	const [reset, setReset] = useState<boolean | null>(null);

	const { $t } = useIntl();

	const sophisticatedHasCertificateOptions = [
		{
			id: YesOrNoOptions.NO,
			label: $t('jurisdictionRequirements.ukSelfCategorisation.optionNo')
		},
		{
			id: YesOrNoOptions.YES,
			label: $t('jurisdictionRequirements.ukSelfCategorisation.sophisticatedHasCertificateOptionsYes')
		}
	];

	const resetOptions = [
		{
			id: YesOrNoOptions.YES,
			label: $t('jurisdictionRequirements.ukSelfCategorisation.optionYes')
		}
	];

	const resetSophisticatedChoice = useCallback((value: boolean) => {
		setSophisticatedFirmName('');
		setReset(value);

		setSophisticatedHasCertificate(null);
	}, []);

	const setUserHasFirm = useCallback((value: boolean) => {
		if (!value) {
			setSophisticatedFirmName('');
		}

		setReset(null);
		setSophisticatedHasCertificate(value);
	}, []);

	return {
		reset,
		resetOptions,
		resetSophisticatedChoice,
		setSophisticatedFirmName,
		setSophisticatedHasCertificate,
		setUserHasFirm,
		sophisticatedFirmName,
		sophisticatedHasCertificate,
		sophisticatedHasCertificateOptions
	};
};
